import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-covidcontrol',
  templateUrl: './covidcontrol.component.html',
  styleUrls: ['./covidcontrol.component.scss']
})
export class CovidcontrolComponent implements OnInit {

  exposition: CardContent = {
    title: 'CovidControl',
    subtitle: 'Daily projection of Covid-19 cases, hospitalisations and ICU admissions',
    image_source: 'assets/images/CovidControl.png',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients, Partners</h4>Epimos, LGA Stuttgart',
      '<h4>Methods</h4>Maximum likelihood parameter estimation',
      '<h4>Technology / Skills</h4>PHP, Javascript, Angular',
      '<h4>Term</h4>2021',
    ]
  };


  constructor() { }

  ngOnInit(): void {
  }

}
